import { Navigate } from "react-router-dom";
import { useAuthStore, useHasHydrated } from "@/stores/authStore";
import { DASHBOARD_ROUTES } from "../constants";
import { Loader2 } from "lucide-react";

interface GuestRouteProps {
  children: React.ReactNode;
}

/**
 * Route guard that redirects authenticated users to their dashboard.
 * Use for login/signup pages that shouldn't be accessible when logged in.
 */
export function GuestRoute({ children }: GuestRouteProps) {
  const user = useAuthStore((s) => s.user);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const hasHydrated = useHasHydrated();

  // Show loading while hydrating from localStorage
  if (!hasHydrated) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader2 className="text-primary h-8 w-8 animate-spin" />
      </div>
    );
  }

  // Redirect to dashboard if already authenticated
  if (isAuthenticated && user) {
    const destination = DASHBOARD_ROUTES[user.role];
    return <Navigate to={destination} replace />;
  }

  return <>{children}</>;
}
